export const COMPANY_DELETE_RESET = 'COMPANY_DELETE_RESET'
export const COMPANY_DELETE_SET_ERROR = 'COMPANY_DELETE_SET_ERROR'
export const COMPANY_DELETE_SET_DELETED = 'COMPANY_DELETE_SET_DELETED'
export const COMPANY_DELETE_TOGGLE_LOADING = 'COMPANY_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/company/delete/mutation_types.js